import { supabase } from './supabase';

/**
 * פורמט מספר כמחיר עם סמל המטבע
 */
export const formatCurrency = (amount: number | string, currencyCode: string): string => {
  let numericAmount: number;
  
  // אם התקבל מחיר כמחרוזת, צריך להמיר אותו למספר
  if (typeof amount === 'string') {
    // הסרת הסימן $ ופסיקים אם קיימים
    numericAmount = parseFloat(amount.replace(/[$,]/g, ''));
  } else {
    numericAmount = amount;
  }
  
  // מיפוי של סמלי מטבעות
  const currencySymbols: Record<string, string> = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'ILS': '₪',
    'JPY': '¥',
    // ניתן להוסיף עוד מטבעות לפי הצורך
  };
  
  const symbol = currencySymbols[currencyCode] || currencyCode;
  
  // בדיקה אם המטבע מוצג לפני הסכום או אחריו (RTL)
  const rtlCurrencies = ['ILS', 'SAR', 'AED', 'EGP', 'JOD', 'KWD', 'LBP', 'QAR', 'OMR', 'BHD', 'TND'];
  
  if (rtlCurrencies.includes(currencyCode)) {
    // בשפות RTL (כמו עברית וערבית) הסמל מופיע אחרי הסכום
    return `${numericAmount.toFixed(0)} ${symbol}`;
  } else {
    // בשפות LTR (כמו אנגלית) הסמל מופיע לפני הסכום
    return `${symbol}${numericAmount.toFixed(0)}`;
  }
};

/**
 * מחזיר את המטבע של המשתמש הנוכחי
 */
export const getUserCurrency = async (): Promise<string> => {
  try {
    // Get the current authenticated user
    const { data: userData } = await supabase.auth.getUser();
    if (!userData?.user) {
      return 'ILS'; // Default to ILS if no user is authenticated
    }

    // Get the user's organization ID
    const { data: profileData, error: profileError } = await supabase
      .from('user_profiles')
      .select('org_id')
      .eq('user_id', userData.user.id)
      .single();

    if (profileError || !profileData?.org_id) {
      return 'ILS'; // Default if can't get org ID
    }

    // Get the organization's currency setting
    const { data: orgData, error: orgError } = await supabase
      .from('organizations')
      .select('currency')
      .eq('id', profileData.org_id)
      .single();

    if (orgError || !orgData?.currency) {
      return 'ILS'; // Default if can't get organization currency
    }

    return orgData.currency;
  } catch (error) {
    console.error('Error getting user currency:', error);
    return 'ILS'; // Default to ILS on error
  }
};

/**
 * מחזיר את סמל המטבע עבור קוד מטבע
 */
export const getCurrencySymbol = (currencyCode: string): string => {
  const currencySymbols: Record<string, string> = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'ILS': '₪',
    'JPY': '¥',
    // ניתן להוסיף עוד מטבעות לפי הצורך
  };
  return currencySymbols[currencyCode] || currencyCode;
};

/**
 * מחזיר את סמל המטבע של המשתמש הנוכחי
 */
export const getUserCurrencySymbol = async (): Promise<string> => {
  const currency = await getUserCurrency();
  return getCurrencySymbol(currency);
}; 